import React from "react";
import Box from "@mui/material/Box";
import {Grid, Typography} from "@mui/material";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import {Link} from "react-router-dom";
import {useKeycloak} from "@react-keycloak/web";
import JoinInnerIcon from '@mui/icons-material/JoinInner';
import DeleteIcon from '@mui/icons-material/Delete';
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {columns} from "../collection/definition";
import TableBody from "@mui/material/TableBody";
import Chip from "@mui/material/Chip";
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import OrderStepper from "./OrderStepper";



const bull = (
    <Box
      component="span"
      sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
      •
    </Box>
  );

export default function Cart() {
  const {keycloak, initialized} = useKeycloak();
  return (
    <>
    
    <Box sx={{marginTop: 4, marginBottom: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
    <Typography variant="h4">Shopping Cart</Typography>
    <Box>
        <Button color="error" sx={{margin: 1}} variant={"outlined"} startIcon={<DeleteIcon />}>Delete All Cards</Button>
        </Box>
</Box>

<Grid container spacing={{xs: 2, sm: 4, md: 4}} columns={{xs: 1, sm: 4, md: 4}}>
    <Grid item xs={1} sm={3} md={3}>
    <Card>
      <CardContent>
        <Box sx={{marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <Link>
            smylek
          </Link>
          <Box>
              <Button color="success" sx={{margin: 1}} variant={"outlined"} startIcon={<JoinInnerIcon />}>Show 40 cards from my Want</Button>
              <Button color="error" sx={{margin: 1}} variant={"outlined"} startIcon={<DeleteIcon />}>Delete Cart</Button>
          </Box>
        </Box>
          
        <Grid container spacing={{xs: 1, sm: 2, md: 2}} columns={{xs: 1, sm: 3, md: 3}}>
          <Grid item xs={1} sm={1} md={1}>
            <Box sx={{borderRadius: 1, padding: 2, bgcolor: 'lightGrey'}}>
              <Box sx={{marginTop: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body1" component="div">
                Articles Value
              </Typography>
              <Typography variant="body1">48,00 zł</Typography>
              </Box>
              <Box sx={{marginTop: 1, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body2">Amount of articles</Typography>
                <Typography variant="body2">2 Articles</Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={1} sm={1} md={1}>
            <Box sx={{borderRadius: 1, padding: 2, bgcolor: 'lightGrey'}}>
              <Box sx={{marginTop: 1, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body1">Shipping</Typography>
                <Typography variant="body1">12,00 zł</Typography>
              </Box>
              <Box sx={{marginTop: 1, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body2">Service Fee</Typography>
                <Typography variant="body2">1,20 zł</Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={1} sm={1} md={1}>
            <Box sx={{borderRadius: 1, padding: 2, bgcolor: 'lightGrey'}}>
              <Box sx={{marginTop: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body1" component="div">
                Total
              </Typography>
              <Typography variant="body1">61,20 zł</Typography>
              </Box>
              <Box sx={{marginTop: 1, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body2">-</Typography>
                <Typography variant="body2"> </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

      <TableContainer>
        <Table sx={{minWidth: 650}} aria-label="simple table">
            <TableHead>
                <TableRow>
                    <TableCell align="left">Product</TableCell>
                    <TableCell align="left">Set</TableCell>
                    <TableCell align="center">Condition</TableCell>
                    <TableCell align="center">Lanuguage</TableCell>
                    <TableCell align="center">Foil</TableCell>
                    <TableCell align="left">Rarity</TableCell>
                    <TableCell align="right">Quantity</TableCell>
                    <TableCell align="right">Price</TableCell>
                    <TableCell align="right">Notes</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                            <TableCell align="left"><Link>Tasigur, the Golden Fang</Link></TableCell>
                            <TableCell align="left"><JoinInnerIcon /></TableCell>
                            <TableCell align="center">
                              <Chip
                                variant={'outlined'}
                                color={'success'}
                                label={'NM'}>
                              </Chip>
                            </TableCell>
                            <TableCell align="center">EN</TableCell>
                            <TableCell align="center"><DoNotDisturbOnIcon color="disabled"/></TableCell>
                            <TableCell align="left">rare</TableCell>
                            <TableCell align="right">1</TableCell>
                            <TableCell align="right">24,00 zł</TableCell>
                            <TableCell align="right">Notatki</TableCell>
            </TableRow>
            <TableRow>
                            <TableCell align="left"><Link>Tasigur, the Golden Fang</Link></TableCell>
                            <TableCell align="left"><JoinInnerIcon /></TableCell>
                            <TableCell align="center">
                              <Chip
                                variant={'outlined'}
                                color={'success'}
                                label={'NM'}>
                              </Chip>
                            </TableCell>
                            <TableCell align="center">EN</TableCell>
                            <TableCell align="center"><DoNotDisturbOnIcon color="disabled"/></TableCell>
                            <TableCell align="left">rare</TableCell>
                            <TableCell align="right">1</TableCell>
                            <TableCell align="right">24,00 zł</TableCell>
                            <TableCell align="right">Notatki</TableCell>
            </TableRow>
          </TableBody>
        </Table>
    </TableContainer>
    </CardContent>
    </Card>

    <Card sx={{marginTop: 4}}>
      <CardContent>
        <Box sx={{marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
        <Link>
          Tasigur
        </Link>
          <Box>
            <Button color="success" sx={{margin: 1}} variant={"outlined"} startIcon={<JoinInnerIcon />}>Show 40 cards from my Want</Button>
              <Button color="error" sx={{margin: 1}} variant={"outlined"} startIcon={<DeleteIcon />}>Delete Cart</Button>
              </Box>
      </Box>

      <Grid container spacing={{xs: 1, sm: 2, md: 2}} columns={{xs: 1, sm: 3, md: 3}}>
          <Grid item xs={1} sm={1} md={1}>
            <Box sx={{borderRadius: 1, padding: 2, bgcolor: 'lightGrey'}}>
              <Box sx={{marginTop: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body1" component="div">
                Articles Value
              </Typography>
              <Typography variant="body1">48,00 zł</Typography>
              </Box>
              <Box sx={{marginTop: 1, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body2">Amount of articles</Typography>
                <Typography variant="body2">2 Articles</Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={1} sm={1} md={1}>
            <Box sx={{borderRadius: 1, padding: 2, bgcolor: 'lightGrey'}}>
              <Box sx={{marginTop: 1, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body1">Shipping</Typography>
                <Typography variant="body1">12,00 zł</Typography>
              </Box>
              <Box sx={{marginTop: 1, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body2">Service Fee</Typography>
                <Typography variant="body2">1,20 zł</Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={1} sm={1} md={1}>
            <Box sx={{borderRadius: 1, padding: 2, bgcolor: 'lightGrey'}}>
              <Box sx={{marginTop: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body1" component="div">
                Total
              </Typography>
              <Typography variant="body1">61,20 zł</Typography>
              </Box>
              <Box sx={{marginTop: 1, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body2">-</Typography>
                <Typography variant="body2"> </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

      <TableContainer>
        <Table sx={{minWidth: 650}} aria-label="simple table">
            <TableHead>
                <TableRow>
                    <TableCell align="left">Product</TableCell>
                    <TableCell align="left">Set</TableCell>
                    <TableCell align="center">Condition</TableCell>
                    <TableCell align="center">Lanuguage</TableCell>
                    <TableCell align="center">Foil</TableCell>
                    <TableCell align="left">Rarity</TableCell>
                    <TableCell align="right">Quantity</TableCell>
                    <TableCell align="right">Price</TableCell>
                    <TableCell align="right">Notes</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                            <TableCell align="left"><Link>Tasigur, the Golden Fang</Link></TableCell>
                            <TableCell align="left"><JoinInnerIcon /></TableCell>
                            <TableCell align="center">
                              <Chip
                                variant={'outlined'}
                                color={'success'}
                                label={'NM'}>
                              </Chip>
                            </TableCell>
                            <TableCell align="center">EN</TableCell>
                            <TableCell align="center"><DoNotDisturbOnIcon color="disabled"/></TableCell>
                            <TableCell align="left">rare</TableCell>
                            <TableCell align="right">1</TableCell>
                            <TableCell align="right">24,00 zł</TableCell>
                            <TableCell align="right">Notatki</TableCell>
            </TableRow>
            <TableRow>
                            <TableCell align="left"><Link>Tasigur, the Golden Fang</Link></TableCell>
                            <TableCell align="left"><JoinInnerIcon /></TableCell>
                            <TableCell align="center">
                              <Chip
                                variant={'outlined'}
                                color={'success'}
                                label={'NM'}>
                              </Chip>
                            </TableCell>
                            <TableCell align="center">EN</TableCell>
                            <TableCell align="center"><DoNotDisturbOnIcon color="disabled"/></TableCell>
                            <TableCell align="left">rare</TableCell>
                            <TableCell align="right">1</TableCell>
                            <TableCell align="right">24,00 zł</TableCell>
                            <TableCell align="right">Notatki</TableCell>
            </TableRow>
          </TableBody>
        </Table>
    </TableContainer>
    </CardContent>
    </Card>

    </Grid>
    <Grid item xs={1} sm={1} md={1}>
        <Grid container spacing={{xs: 1}} columns={{xs: 1, sm: 2, md: 2}}>
        <Card sx={{marginTop: 4, width: '100%' }}>
            <CardContent>
              <Box sx={{marginTop: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="h6" component="div">
                Cart Overview
              </Typography>
              <Typography variant="h6">72,00 zł</Typography>
              </Box>
              
              {/* <CardActions>
                              <Button color="success" sx={{margin: 1}} variant={"contained"}>Proceed to Checkout</Button>
              </CardActions> */}


              <Box sx={{marginTop: 1, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <Link>smylek</Link>
                <Typography variant="body2">24,00 zł</Typography>
              </Box>
              <Box sx={{marginTop: 1, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <Link>Tasigur</Link>
                <Typography variant="body2">24,00 zł</Typography>
              </Box>
              <Box sx={{marginTop: 4, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body2">Number of orders</Typography>
                <Typography variant="body2">1 Sellers</Typography>
              </Box>
              <Box sx={{marginTop: 1, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body2">Amount of articles</Typography>
                <Typography variant="body2">1 Articles</Typography>
              </Box>
              <Box sx={{marginTop: 4, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body2">Articles Value</Typography>
                <Typography variant="body2">48,00 zł</Typography>
              </Box>
              <Box sx={{marginTop: 1, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body2">Shipping</Typography>
                <Typography variant="body2">24,00 zł</Typography>
              </Box>
              <Box sx={{marginTop: 1, marginBottom: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography variant="body2">Service Fee</Typography>
                <Typography variant="body2">2,40 zł</Typography>
              </Box>
            </CardContent>
        </Card>
        <Card sx={{marginTop: 4, width: '100%' }}>
            <CardContent>
              <Typography variant="h6" component="div">
                Shipping Address
              </Typography>
              <Typography variant="body2" sx={{marginTop: 1}} >Daniel Smyl</Typography>
        <Typography variant="body2">Fieldorfa-Nila 14/104</Typography>
        <Typography variant="body2">31-209 Kraków</Typography>
        <Typography variant="body2">+48 691 399 735</Typography>
        <Typography variant="body2">smylek@gmail.com</Typography>
            </CardContent>
            <CardActions>
                              <Button>Choose shipping address</Button>
                      </CardActions>
        </Card>
        </Grid>
    </Grid>
</Grid>

      <Box>
          <Box height={48}/>
      </Box>

      <Box>
          <Box height={48}/>
      </Box>            
  </>
  )
}
